<template>
  <div>
    <div class="p-8">
      <ContactRequestList ref="contactRequestList" :project-id="projectId" />
    </div>
  </div>
</template>

<script>
import ContactRequestList from './contactRequests/components/contact-request-list.vue';

export default {
  components: {
    ContactRequestList,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  methods: {
    resetList() {
      this.$refs.contactRequestList.resetList();
    },
  },
};
</script>
